import React from "react";
import { useAuth } from "~/contexts/AuthContext";
import { UnauthorizedAdminAccess } from "~/components";

function PermissionRoute({ children, requiredPermissions, area }) {
    const { user, admin } = useAuth();
    
    // Determine which user session to check based on the area
    const currentUser = area === "AdminArea" ? admin : user;

    if (!currentUser) return children;

    // Permission-based access control
    if (requiredPermissions && requiredPermissions.length > 0) {
        const roles = currentUser.Roles || currentUser.roles || [];
        const roleString = currentUser.Role || currentUser.role;

        // Super Admin bypass
        const isSuperAdmin = roleString === 'Super Admin' || (Array.isArray(roles) && roles.includes('Super Admin'));

        if (!isSuperAdmin) {
            const userPermissions = currentUser.Permissions || currentUser.permissions || [];
            const hasPermission = requiredPermissions.some(p => userPermissions.includes(p));

            if (!hasPermission) {
                return (
                    <UnauthorizedAdminAccess 
                        requiredPermission={requiredPermissions[0]} 
                        moduleName="this page" 
                    />
                );
            }
        }
    }

    return children;
}

export default PermissionRoute;
